import { render } from "./RegisterUser.vue?vue&type=template&id=90c946a2&scoped=true&ts=true"
import script from "./RegisterUser.vue?vue&type=script&lang=ts"
export * from "./RegisterUser.vue?vue&type=script&lang=ts"

import "./RegisterUser.vue?vue&type=style&index=0&id=90c946a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c946a2"]])

export default __exports__